import { render, staticRenderFns } from "./exercise-edit.vue?vue&type=template&id=373d831a&scoped=true"
import script from "./exercise-edit.vue?vue&type=script&lang=js"
export * from "./exercise-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373d831a",
  null
  
)

export default component.exports